import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  // Button,
} from "@mui/material";
// import { Link } from "react-router-dom";

import "./AboutUsSection.css";
import { whyChooseUs } from "../../data/AboutUs.js";

export default function AboutUsSection() {
  return (
    <Box className="about-us-section">
      <div className="container">
        <div className="about-us-content">
          {/* Left Section */}
          <div className="about-us-left">
            <Typography variant="h4" className="section-title">
              Who We Are
            </Typography>
            <Typography variant="body1" className="section-text">
              VR Builders and Promoters is a leading construction company
              dedicated to delivering high-quality residential and commercial
              projects. Our mission is to transform your vision into reality
              with precision, safety, and sustainable practices.
            </Typography>
            <Typography variant="body1" className="section-text">
              We focus on innovation, reliability, and excellence to ensure
              every project exceeds expectations. From planning to execution,
              our experienced team manages every detail with care and expertise.
            </Typography>
            {/* Not available yet */}
            {/* <Button
              component={Link}
              to="/about"
              variant="contained"
              className="learn-more-btn"
            >
              Learn More
            </Button> */}
          </div>

          {/* Right Section */}
          <div className="about-us-right">
            <Typography variant="h4" className="section-title">
              Why Choose Us
            </Typography>
            <List>
              {whyChooseUs.map((item) => (
                <ListItem key={item.text} className="list-item">
                  <ListItemIcon className="list-icon">{item.icon}</ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography className="list-text">{item.text}</Typography>
                    }
                  />
                </ListItem>
              ))}
            </List>
          </div>
        </div>
      </div>
    </Box>
  );
}
